import { render } from "./SponsorView.vue?vue&type=template&id=10ba3e9c"
import script from "./SponsorView.vue?vue&type=script&lang=js"
export * from "./SponsorView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__